import React, { useEffect } from 'react'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'

export const deleteMeContext: SplitScreenContext = {
  id: 'delete-me',
  title: 'Delete Me',
  message: '',
  contentSide: 'left',
}

const DeleteMePage = () => {
  useEffect(() => {}, [])

  return (
    <div>
      Ivy takes your privacy seriously. If you would like to delete your account, please send your
      full name and telephone number us at{' '}
      <a className="simple-link" href="mailto:support@ivyapp.com">
        support@ivyapp.com
      </a>
      .<br />
      <br />
      After confirming your identity, we will remove all account data from our servers your within
      24 hours.
    </div>
  )
}

export default DeleteMePage
